import {
  sortDestinationIdFormat,
  stationProcessingSessionIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { StationProcessingSessionToteBindingViewSchema } from "./station-processing-session";

export const bindSortingTote = {
  name: "bindSortingTote" as const,
  input: z.object({
    sessionId: stationProcessingSessionIdFormat.schema,
    storageLocationId: storageLocationIdFormat.schema,
    sortDestinationId: sortDestinationIdFormat.schema,
  }),
  output: z.object({
    bindings: z.array(StationProcessingSessionToteBindingViewSchema),
  }),
};
